import {
    LOGOUT,
    FETCH_SELECTED_PROJECT_MEMBER_LIST,
    FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST,
    ADD_MEMBER_TO_PROJECT,
    REMOVE_MEMBER_FROM_PROJECT,
    UPDATE_PROJECT_MEMBER_AUTH,
    UPDATE_LOADING_STATUS,
    UPDATE_PROJECT_STATUS
} from '../ActionTypes'

const API_URL = process.env.API_URL

const showLoadingScreen = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Saving...'
        }
    }
}

const closeLoadingScreen = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

export const logout = () => {
    return {
        type: LOGOUT
    }
}

// FETCH Project Member List
const requestProjectMemberList = () => {
    return {
        type: FETCH_SELECTED_PROJECT_MEMBER_LIST,
        payload: {}
    }
}

const receiveProjectMemberList = (json) => {
    return {
        type: FETCH_SELECTED_PROJECT_MEMBER_LIST,
        payload: json
    }
}

export const fetchProjectMemberList = (token, projectId) => {
    return dispatch => {
        dispatch(requestProjectMemberList())
        return fetch(`${API_URL}/project/${projectId}/member`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveProjectMemberList(json.result))
            })
    }
}

// FETCH Project Available Member List
const requestProjectAvailableMemberList = () => {
    return {
        type: FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST,
        payload: undefined
    }
}

const receiveProjectAvailableMemberList = (json) => {
    return {
        type: FETCH_SELECTED_PROJECT_AVAILABLE_MEMBER_LIST,
        payload: json
    }
}

export const fetchProjectAvailableMemberList = (token, projectId) => {
    return dispatch => {
        dispatch(requestProjectAvailableMemberList())
        return fetch(`${API_URL}/project/${projectId}/member/available`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveProjectAvailableMemberList(json.result))
            })
    }
}

// ADD member to project
const requestAddMemberToProject = () => {
    return {
        type: ADD_MEMBER_TO_PROJECT,
        payload: true
    }
}

const receiveAddMemberToProjectResult = () => {
    return {
        type: ADD_MEMBER_TO_PROJECT,
        payload: false
    }
}

export const addMemberToProject = (token, projectId, memberId) => {
    return dispatch => {
        dispatch(requestAddMemberToProject())
        return fetch(`${API_URL}/project/${projectId}/member/add`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberId })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveAddMemberToProjectResult()))
    }
}

// REMOVE member to project
const requestRemoveMemberFromProject = () => {
    return {
        type: REMOVE_MEMBER_FROM_PROJECT,
        payload: true
    }
}

const receiveRemoveMemberFromProjectResult = () => {
    return {
        type: REMOVE_MEMBER_FROM_PROJECT,
        payload: false
    }
}

export const removeMemberFromProject = (token, projectId, memberId) => {
    return dispatch => {
        dispatch(requestRemoveMemberFromProject())
        return fetch(`${API_URL}/project/${projectId}/member/remove`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberId })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveRemoveMemberFromProjectResult()))
    }
}

// UPDATE project member auth
const requestUpdateProjectMemberAuth = () => {
    return {
        type: UPDATE_PROJECT_MEMBER_AUTH,
        payload: true
    }
}

const receiveUpdateProjectMemberAuthResult = () => {
    return {
        type: UPDATE_PROJECT_MEMBER_AUTH,
        payload: false
    }
}

export const updateProjectMemberAuth = (token, projectId, memberId, isAuthorized) => {
    return dispatch => {
        dispatch(requestUpdateProjectMemberAuth())
        return fetch(`${API_URL}/project/${projectId}/member/auth`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberId, isAuthorized })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveUpdateProjectMemberAuthResult()))
    }
}

// UPDATE projetc status
const requestUpdateProjectStatus = () => {
    return {
        type: UPDATE_PROJECT_STATUS,
        payload: true
    }
}

const receiveUpdateProjectStatusResult = () => {
    return {
        type: UPDATE_PROJECT_STATUS,
        payload: false
    }
}

export const updateProjectStatus = (token, projectId, status) => {
    return dispatch => {
        dispatch(requestUpdateProjectStatus())
        dispatch(showLoadingScreen())
        return fetch(`${API_URL}/project/${projectId}/status`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ status })
            })
            .then(response => response.json())
            .then(json => {
                dispatch(closeLoadingScreen())
                dispatch(receiveUpdateProjectStatusResult())
            })
    }
}



// WEBPACK FOOTER //
// ./src/App/AppActions.js